import React from 'react';
import './NoStockMessage.css';

function NoStockMessage() {
    return (
        <div className='no-stock-message'>
            <div className='no-stock-message_title'>Producto sin stock</div>
            <div className='no-stock-message_description'>Por favor, acérquese a un ejecutivo</div>
        </div>
    );
}

export default NoStockMessage;